module.exports = __webpack_public_path__ + "img/arrow-up.0bdad807.svg";